//@ts-nocheck
import infoButton from 'ewi-ui/components/2-molecules/InfoButton/InfoButton.js';
import headerNavigation from 'ewi-ui/components/3-organisms/HeaderNavigation/HeaderNavigation.ts';
import cardSlider from 'ewi-ui/components/3-organisms/CardSlider/CardSlider.ts';
import cardSliderItem from 'ewi-ui/components/2-molecules/CardSliderItem/CardSliderItem.js';
import chatEvents from 'ewi-ui/components/3-organisms/FooterContact/chat/chat_iadvize_track.js';
import chatIadvizeModule from 'ewi-ui/components/3-organisms/FooterContact/chat/chat_iadvize.js';
import 'ewi-ui/components/3-organisms/Accordion/Accordion.js';
import 'ewi-ui/components/3-organisms/FaqThemeCardList/FaqThemeCardList.js';
import 'ewi-ui/components/3-organisms/NewsCardList/NewsCardList.js';
import './helpers/consentActions.js';
import './helpers/reseller.js';
import './helpers/ripple.js';
import './helpers/chat.js';
import './helpers/basicValidation.js';
import './helpers/linkTracking.js';
import './helpers/voucherTracking.js';

window.addEventListener('load', (event) => {
  infoButton.init();
  headerNavigation.init();
  cardSlider.init();
  cardSliderItem.init();
  chatEvents.init();
  window.chatIadvise = {
    setup: chatIadvizeModule.setup,
  };
});
